import { Box } from "@mui/material";
import {
  BillingTypeFormFacility,
  DepositCategory,
  DepositCategoryManual,
  PaymentKbn,
  Prefectures,
} from "../../../assets/data/Constants";
import TkButton from "../../../components/atoms/TkButton";
import TkSelectForm from "../../../components/atoms/TkSelectForm";
import { TkGetCode, TkGetCodeList } from "../../../utils/TkGetCode";
import { changeAmountFormat } from "../../../utils/useTools";

// 請求データボタン非表示
function funClaimBodyList(
  handleLinkClick: any,
  res?: any,
  handleBtnClick?: any,
  applyId?: number
) {
  const data = [
    {
      children: res ? (
        <Box
          data-testid="SCRW160002link"
          className="link"
          onClick={() => {
            handleLinkClick(res);
          }}
        >
          {res.invoiceId}
        </Box>
      ) : (
        <TkButton onClick={handleBtnClick}>選択</TkButton>
      ),
    },
    {
      children: res ? res.billingDate : "",
      align: "center",
    },
    {
      children: res ? changeAmountFormat(res.billingAmt) : "",
      align: "right",
    },
    {
      children:
        res.invoiceKbnCd === BillingTypeFormFacility["退職手当金返還金"]
          ? res.billingAddressOthers ?? res.billingStaffName
          : res.invoiceKbnCd === BillingTypeFormFacility["都道府県補助金"]
          ? TkGetCode(Prefectures, res.billingPrefectureCd)
          : `${res.billingContractorNo ?? ""}:${
              res.billingContractorName ?? ""
            }`,
    },
    {
      children: res ? getKeyByValue(res.billingKbn, applyId) : "",
    },
  ];

  return data;
}

// 請求データボタン表示
function funClaimBtnBodyList(handleBtnClick: any) {
  const data = [
    {
      children: <TkButton onClick={handleBtnClick}>選択</TkButton>,
    },
    {
      children: "",
    },
    {
      children: "",
    },
    {
      children: "",
    },
    {
      children: "",
    },
  ];

  return data;
}

// 入金データ
function fundepositBodyList(
  res: any,
  isDisable: boolean,
  onGetValue: any,
  error?: boolean
) {
  const data = [
    [
      {
        children: res?.depositId,
      },
      {
        children: res?.depositNo,
      },
      {
        children: res?.depositDate,
        align: "center",
      },
      {
        children: changeAmountFormat(res?.depositAmt),
        align: "right",
      },
      {
        children: res?.fromRequesterName,
      },
      {
        children:
          res &&
          res.fromBankName !== null &&
          res.fromBankName !== "" &&
          res.fromBranchName !== null &&
          res.fromBranchName !== ""
            ? (res.fromBankName ?? "") + "/" + (res.fromBranchName ?? "")
            : "",
      },
      {
        children: (
          <TkSelectForm
            label="区分"
            selectPropsList={
              isDisable
                ? TkGetCodeList(DepositCategory)
                : TkGetCodeList(DepositCategoryManual)
            }
            wantToSetValue={res?.depositKbn}
            disabled={isDisable}
            onGetValue={onGetValue}
            error={error}
            errorMessage={error ? "選択してください" : ""}
          ></TkSelectForm>
        ),
      },
    ],
  ];

  return data;
}

//　既存入金データ
function fundepositBodyLists(
  listData: any,
  isDisable: boolean,
  onGetValue: any
) {
  const dataList: any[] = [];
  listData.forEach((res: any) => {
    const data = [
      {
        children: res.depositId,
      },
      {
        children: res.depositNo,
      },
      {
        children: res.depositDate,
        align: "center",
      },
      {
        children: changeAmountFormat(res.depositAmt),
      },
      {
        children: res.fromRequesterName,
      },
      {
        children:
          res.bankName && res.branchName
            ? (res.bankName ?? "") + ":" + (res.branchName ?? "")
            : "",
      },
      {
        children: (
          <TkSelectForm
            label="区分"
            selectPropsList={TkGetCodeList(DepositCategory)}
            wantToSetValue={res.invoiceClass}
            disabled={isDisable}
            onGetValue={onGetValue}
          ></TkSelectForm>
        ),
      },
    ];
    dataList.push(data);
  });

  return dataList;
}

function funStatusBodyList(res: any) {
  const statusBodyList: any[] = [];
  for (let i in res) {
    let createDate = new Date(res[i].createDate);
    const data = [
      {
        children: res[i].managerName,
      },
      {
        children: res[i].process,
      },
      {
        children:
          createDate.getFullYear() +
          "/" +
          (createDate.getMonth() + 1) +
          "/" +
          createDate.getDate(),
      },
      {
        children: res[i].processComment,
      },
    ];
    statusBodyList.push(data);
  }

  return statusBodyList;
}

function getKeyByValue(value: string, applyId?: number): string | undefined {
  const propertyEnum = applyId ? PaymentKbn : BillingTypeFormFacility;
  for (const key in propertyEnum) {
    if (propertyEnum[key as keyof typeof propertyEnum] === value) {
      return key;
    }
  }
  return undefined;
}

export {
  funClaimBodyList,
  funClaimBtnBodyList,
  funStatusBodyList,
  fundepositBodyList,
  fundepositBodyLists,
};
